<template>
  <div class="InfoCardContainer">
    <div class="AboutSection">
      <img src="../assets/images/pals.png" alt="pals">
      <p>High Tides is a project by <a href="https://www.instagram.com/fuchsiamacaree/" target="_blank">Fuchsia MacAree</a> and <a href="https://www.instagram.com/briggsrogers/" target="_blank">Brian Rogers</a>.</p>
      <p>Read Irish Water Safety’s <a href="https://watersafety.ie/open-water-swimming/" target="_blank">tips</a> on open water swimming and be sure to check out the Outdoor Swimming Society's<a href="https://www.outdoorswimmingsociety.com/category/survive/seas/"> best practices.</a></p>
      
      <p><a href="https://rnli.org/support-us/give-money/donate" target="_blank">Donate</a> to the RNLI.</p>
      <p>Fuchsia welcomes feedback and suggestions <a href="https://www.instagram.com/fuchsiamacaree/" target="_blank">on Instagram.</a></p>
      <p>If you would like offset our monthly server costs, you can tip us <a href="https://ko-fi.com/Z8Z2261T1" target="_blank">here!</a></p>
      <p class="Warning">Never swim alone. Keep an eye on each other.</p>
    </div>
  </div>
    
</template>

<script>

export default {
    name: 'InfoCard'
  }
</script>

<style lang="scss">
.InfoCardContainer{
 
  background-color: var(--dark-blue);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;

  display:flex;
  justify-content: center;

  a{
    color: var(--mid-blue);
  }

  .AboutSection{
    width: 100%;
    overflow-y: hidden;
    font-size: 20px;
    padding: 10vw;
    color: var(--off-white);
    animation: rise .3s ease-in-out;
    overflow: scroll;

    img{
      margin-top: 50px;
      width: 130px;
      height: 48px;
    }

    .Warning{ color: var(--yellow);}
  }
}
</style>

